import styled from 'styled-components';
export const Root = styled.div `
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .desc{
    padding-left:45px;
  }

  .wrap{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .wrap li{
    position: relative;
    width: 120px;
    height: 90px;
    border: 1px solid #e2e2e2;
    list-style: none;
    margin: 6px;
  }

  .wrap li .upload-item,.wrap li .upload-icon{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .wrap li .upload-icon{
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
  }

  .wrap li .upload-icon-eye{
    position: absolute;
    top: -10px;
    right: -8px;
    color: #FF571A;
  }

  .upload-item i,.wrap li .upload-icon{
    color: #888;
  }

  .wrap li .upload-icon i{
    // color: #FF571A;
    margin: 0 6px;
  }

  .hide{
    display: none!important;
  }

  .wrap li:hover .upload-icon{
    display: flex;
  }

  .wrap li .upload-item img{
    width: 100%;
    height: 100%;
  }
  .wrap li .upload-icon-eye img{
    width: 100%;
    height: 100%;
  }
`;
